import React__default from 'react';
import 'react/jsx-runtime';
import Calendar from '../../../node_modules/@zooplus/icons/dist/es/components/Calendar.js';
import OrderParcel from '../../../node_modules/@zooplus/icons/dist/es/components/OrderParcel.js';
import Pencil from '../../../node_modules/@zooplus/icons/dist/es/components/Pencil.js';
import { ModalWrapper, ModalBody, P1, ModalFooter, ModalPrimaryButton } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import img from '../assets/images/new_autoship_graphics.png.js';
import styles from './InfoModal.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const InfoModal = (props) => {
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const closeModal = () => {
        props.setIsOpen(false);
    };
    return (React__default.createElement(ModalWrapper, { closeBtnAriaLabel: "Close", heading: t('checkout.common.autoshipment'), headingId: "aus-info-modal", isOpen: props.isOpen, onClose: closeModal, className: styles.modalWrapper, size: "sm" },
        React__default.createElement(ModalBody, { className: styles.modalBody },
            React__default.createElement("img", { className: styles.cartLogo, src: img, alt: "Autoshipment cart logo" }),
            React__default.createElement(P1, { className: styles.firstSentence }, t('checkout.header.sentence-1')),
            React__default.createElement("div", { className: styles.benefit },
                React__default.createElement("span", { className: styles.dot },
                    React__default.createElement(Calendar, { className: styles.icon })),
                React__default.createElement(P1, { className: styles.text }, t('checkout.header.modal.benefit-1'))),
            React__default.createElement("div", { className: styles.benefit },
                React__default.createElement("span", { className: styles.dot },
                    React__default.createElement(OrderParcel, { className: styles.icon })),
                React__default.createElement(P1, { className: styles.text }, t('checkout.header.modal.benefit-2'))),
            React__default.createElement("div", { className: styles.benefit },
                React__default.createElement("span", { className: styles.dot },
                    React__default.createElement(Pencil, { className: styles.icon })),
                React__default.createElement(P1, { className: styles.text }, t('checkout.header.modal.benefit-3')))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(ModalPrimaryButton, { onClick: closeModal }, t('checkout.common.close')))));
};

export { InfoModal };
//# sourceMappingURL=InfoModal.js.map
